import {
  FETCH_DEPARTMENTS,
  FETCH_DEPARTMENTS_SUCCESS,
  FETCH_DEPARTMENTS_FAILURE,
  CREATE_DEPARTMENT_REQUEST,
  CREATE_DEPARTMENT_SUCCESS,
  CREATE_DEPARTMENT_FAILURE,
  DELETE_DEPARTMENT,
  DELETE_DEPARTMENT_SUCCESS,
  DELETE_DEPARTMENT_FAILURE,
} from "./actionTypes";

// Fetch Departments
export const fetchDepartments = (companyId) => ({
  type: FETCH_DEPARTMENTS,
  payload: { companyId },
});

export const fetchDepartmentsSuccess = (departments) => ({
  type: FETCH_DEPARTMENTS_SUCCESS,
  payload: departments,
});

export const fetchDepartmentsFailure = (error) => ({
  type: FETCH_DEPARTMENTS_FAILURE,
  payload: error,
});

// Create Department
export const createDepartment = (formData) => ({
  type: CREATE_DEPARTMENT_REQUEST,
  payload: { formData },
});

export const createDepartmentSuccess = (response) => ({
  type: CREATE_DEPARTMENT_SUCCESS,
  payload: response,
});

export const createDepartmentFailure = (error) => ({
  type: CREATE_DEPARTMENT_FAILURE,
  payload: error,
});

// Delete Department
export const deleteDepartment = (deleteDepart) => ({
  type: DELETE_DEPARTMENT,
  payload: deleteDepart,
});

export const deleteDepartmentSuccess = (response) => ({
  type: DELETE_DEPARTMENT_SUCCESS,
  payload: response,
});

export const deleteDepartmentFailure = (error) => ({
  type: DELETE_DEPARTMENT_FAILURE,
  payload: error,
});
